import * as styles from './styles.css';
import { TLinkButtonSize } from './types';

export const SIZE_TO_CLASS: { [key in TLinkButtonSize]: string } = {
  M: styles['middle'],
  L: styles['large'],
  XL: styles['extra-large'],
};
